// useauth.js

import { useMemo } from "react";

const parseJWT = (token) => {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    return JSON.parse(jsonPayload);
  } catch {
    return null;
  }
};

const useAuth = () => {
  const token = localStorage.getItem("token");
  const role = localStorage.getItem("role");
  const isAuthenticated = !!token;

  const user = useMemo(() => (token ? parseJWT(token) : null), [token]);

  const isAdmin = role === "admin";
  const isModerator = role === "moderator";

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    localStorage.removeItem("userId");
    window.location.href = "/login";
  };

  const hasRole = (allowedRoles = []) => {
    return allowedRoles.includes(role);
  };

  return {
    token,
    role,
    user,
    isAdmin,
    isModerator,
    isAuthenticated,
    hasRole,     // ✨ Bonus: Flexible role check
    logout       // ✨ Bonus: One-liner logout
  };
};

export default useAuth;
